module.exports = __webpack_public_path__ + "media/images/product/f_j-2b356709fb3baaea6192fdafeea88e5a.png";